/* Iron-Bulls: „In den Warenkorb“-Buttons auf der Startseite.
   <button data-ib-add="VARIANT_ID,VARIANT_ID" data-ib-done="Hinzugefügt"> – legt alle Varianten je 1× in den Warenkorb
   und aktualisiert das Warenkorb-Symbol im Header (Section „cart-icon-bubble“). */
(function () {
  if (window.ibCartAddInit) return;
  window.ibCartAddInit = true;

  function refreshBubble() {
    fetch(window.location.pathname + '?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !data['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
        var inner = doc.querySelector('.shopify-section');
        el.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
        bump(el.querySelector('.cart-count-bubble') || el);
      })
      .catch(function () {});
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CHECK = '<svg class="ib-added-check" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  // Warenkorb-Symbol: kurzer „Hüpfer“, damit sichtbar wird, wohin das Produkt gegangen ist
  function bump(target) {
    if (!target || !target.animate) return;
    var frames = reduce
      ? [{ opacity: 0.4 }, { opacity: 1 }]
      : [{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }];
    target.animate(frames, { duration: reduce ? 200 : 320, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ib-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var ids = btn.getAttribute('data-ib-add').split(',').filter(Boolean);
    var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (err) { throw err; }); return r.json(); })
      .then(function () {
        btn.removeAttribute('aria-busy');
        var redirect = btn.getAttribute('data-ib-redirect');
        if (redirect) { window.location.href = redirect; return; }
        btn.classList.add('is-added');
        btn.innerHTML = CHECK + '<span>' + (btn.getAttribute('data-ib-done') || 'Hinzugefügt') + '</span>';
        refreshBubble();
        setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added'); btn.textContent = label; }, 2500);
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        btn.textContent = (err && err.description) ? 'Nicht verfügbar' : label;
      });
  });
})();
